// Generated by Melange

import * as Stdlib__List from "melange/list.js";

function image(media_type) {
  return Stdlib__List.mem(media_type, {
    hd: "image/png",
    tl: {
      hd: "image/jpeg",
      tl: {
        hd: "image/gif",
        tl: {
          hd: "image/webp",
          tl: {
            hd: "image/avif",
            tl: /* [] */ 0
          }
        }
      }
    }
  });
}

export {
  image,
}
/* No side effect */
